<template>
  <svg
    width="41"
    height="42"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="21" r="20.5" fill="#FFF7E4" />
    <path
      d="M29.3859 18.8383L23.6901 18.0171L21.1439 12.8962C21.0743 12.7559 20.9599 12.6424 20.8186 12.5735C20.4642 12.3999 20.0334 12.5445 19.8562 12.8962L17.31 18.0171L11.6142 18.8383C11.4572 18.8606 11.3136 18.934 11.2037 19.0453C11.0708 19.1808 10.9975 19.3631 11.0001 19.5521C11.0026 19.7412 11.0807 19.9215 11.2171 20.0535L15.3381 24.0394L14.3645 29.6677C14.3417 29.7987 14.3563 29.9333 14.4067 30.0564C14.4571 30.1795 14.5412 30.2862 14.6496 30.3643C14.7579 30.4424 14.8862 30.4887 15.0198 30.4982C15.1534 30.5077 15.287 30.4798 15.4054 30.4177L20.5 27.7605L25.5947 30.4177C25.7337 30.4912 25.8953 30.5157 26.0501 30.489C26.4404 30.4222 26.7029 30.055 26.6356 29.6677L25.662 24.0394L29.783 20.0535C29.8951 19.9444 29.9692 19.802 29.9916 19.6462C30.0522 19.2567 29.7785 18.8962 29.3859 18.8383Z"
      fill="url(#paint0_linear_2001_4387)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2001_4387"
        x1="11.3384"
        y1="40.4818"
        x2="29.7199"
        y2="41.8233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCCE6E" />
        <stop offset="1" stop-color="#FAC328" />
      </linearGradient>
    </defs>
  </svg>
</template>
